<template>
    <v-container fluid>
        <v-row>
            <v-col cols="6">
            <v-subheader class="font-weight-bold pr-5 json-key-title">
                Alert Id:
            </v-subheader>
            </v-col>
            <v-col cols="6">
            <v-subheader>
                {{ info.alertId }}
            </v-subheader>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
            <v-subheader class="font-weight-bold pr-5 json-key-title">
                Alert Type:
            </v-subheader>
            </v-col>
            <v-col cols="6">
            <v-subheader>
                {{ formatIssueType() }}
            </v-subheader>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
            <v-subheader class="font-weight-bold pr-5 json-key-title">
                Alert Amount:
            </v-subheader>
            </v-col>
            <v-col cols="6">
            <v-subheader>
                {{ info.amount }} {{ info.currency }}
            </v-subheader>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
                <v-subheader class="font-weight-bold pr-5 json-key-title">
                    Alert Action:
                </v-subheader>
            </v-col>
            <v-col cols="6">
                <v-select
                    v-model="form.outcome"
                    :items="getActions()"
                    item-text="text"
                    item-value="text"
                    label="Select a response"
                    persistent-hint
                    return-object
                    single-line
                    required
                    solo
                    :rules="rules.required"
                    hint="*Required"
                ></v-select>
            </v-col>
        </v-row>

        <v-row v-if="newRefund()" style="margin-bottom: 1em;">
            <v-col cols="6">
                <v-subheader class="font-weight-bold pr-5 json-key-title">
                    Refund Info:
                </v-subheader>
                </v-col>
                <v-col cols="6">
                <v-subheader>
                    <div>This will refund an amount of {{ info.amount }} {{ info.currency }} upon submission</div>
                </v-subheader>
            </v-col>
        </v-row>

        <!-- <v-row v-if="prevRefund()" style="margin-bottom: 1em;">
            <v-col cols="6">
                <v-subheader class="font-weight-bold pr-5 json-key-title">
                    Refunded Amount:
                </v-subheader>
            </v-col>
            <v-col cols="6">
                <v-subheader>
                    {{ calcTwoDp(refund.amount) }} {{ info.currency }}
                </v-subheader>
            </v-col>
        </v-row> -->

        <!-- <v-row v-if="prevRefund()" style="margin: 0em">
            <v-container fill-height fluid>
                <v-row align="center" justify="center">
                    <v-card outline width="80%">
                        <v-card-title>
                            Transaction Log
                        </v-card-title>
                        <v-card-text>
                            <v-timeline v-if="getTimelineStatus()"
                                align-top
                                dense
                            >
                                <v-timeline-item
                                v-for="(transaction, index) in form.transactions"
                                :key="transaction.timestamp"
                                :color="transaction.color"
                                small
                                >
                                <div>
                                    <v-row>
                                        <v-col cols="6">
                                            <div class="font-weight-normal">
                                                <strong>{{ txFmtType(transaction.type) }}</strong> @ {{ transaction.timestamp }}
                                            </div>
                                            <div>
                                                {{ transaction.amount }} {{ transaction.currency }}
                                            </div>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-container fill-height fluid>
                                                <v-row align="center" justify="center">
                                                    <v-btn @click="txDeleteConfirm(index)" outlined text icon color="grey" style="border-color: rgb(255 0 0)">
                                                        <v-icon color="red" size="22">
                                                            mdi-delete
                                                        </v-icon>
                                                    </v-btn>
                                                </v-row>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                </div>
                                </v-timeline-item>
                            </v-timeline>
                        </v-card-text>
                        <v-card-actions>
                            <v-container fluid>
                                <v-row align="center" justify="space-around">
                                    <v-btn
                                    color="primary"
                                    @click="txAdd('fullRefund')"
                                    :disabled="tx.disable.fullRefund == 1"
                                    >
                                        Add Full Refund
                                    </v-btn>
                                    <v-btn
                                    color="primary"
                                    @click="txAdd('partialRefund')"
                                    :disabled="tx.disable.partialRefund == 1"
                                    >
                                        Add Partial Refund
                                    </v-btn>
                                </v-row>
                            </v-container>
                        </v-card-actions>
                    </v-card>
                </v-row>
            </v-container>
        </v-row> -->

        <template v-if="prevRefund()">
            <v-row>
                <v-col
                cols="12"
                sm="6"
                offset-sm="3"
                >
                    <v-card>
                        <v-card-title class="primary">
                            <span class="text-h5 white--text">Transaction Log</span>

                            <v-spacer></v-spacer>
                            
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                    dark
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item
                                    @click="txAdd('fullRefund')"
                                    :disabled="tx.disable.fullRefund == 1"
                                    link
                                    >
                                        Add Full Refund
                                    </v-list-item>
                                    <v-list-item
                                    @click="txAdd('partialRefund')"
                                    :disabled="tx.disable.partialRefund == 1"
                                    link
                                    >
                                        Add Partial Refund
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-card-title>
                        <v-list two-line>
                            <v-list-item>
                                <v-row>
                                    <v-col cols="6">
                                        <v-subheader class="font-weight-bold pr-5 json-key-title">
                                            Refunded Amount:
                                        </v-subheader>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-subheader>
                                            {{ calcTwoDp(refund.amount) }} {{ info.currency }}
                                        </v-subheader>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <div v-if="getTimelineStatus()">
                                <template v-for="(transaction, index) in form.transactions">

                                    <v-divider :key="transaction.timestamp"></v-divider>

                                    <v-list-item :key="transaction.timestamp">
                                        
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <v-subheader>
                                                    <strong style="margin-right: 1em;">{{ txFmtType(transaction.type) }}</strong>{{ transaction.timestamp }}
                                                </v-subheader>
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="v-subheader theme--light" style="margin-top: -2em;">
                                                {{ transaction.amount }} {{ transaction.currency }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-avatar>
                                            <v-btn @click="txDeleteConfirm(index)" outlined text icon color="grey" style="border-color: rgb(255 0 0)">
                                                <v-icon color="red" size="22">
                                                    mdi-delete
                                                </v-icon>
                                            </v-btn>
                                        </v-list-item-avatar>

                                    </v-list-item>

                                    <!-- <v-divider :key="transaction.timestamp" v-if="showTimelimeDivider(index)"></v-divider> -->

                                </template>
                            </div>
                        </v-list>
                    </v-card>
                </v-col>
            </v-row>
        </template>

        <v-row style="margin-top: 1em; margin-bottom: 2em">
            <v-container fill-height fluid>
                <v-row align="center" justify="space-around">
                    <v-btn color="success" @click="sendAction('submit')">Submit</v-btn>
                    <v-btn color="warning" @click="sendAction('reset')">Reset</v-btn>
                    <v-btn color="error" @click="sendAction('close')">Close</v-btn>
                </v-row>
            </v-container>
        </v-row>

        <!-- Snackbar -->
        <v-snackbar
            v-model="snackbar.show"
            :color="snackbar.colour"
            timeout="5000"
            bottom
            rounded="pill"
            style="z-index: 1000;"
        >
            {{ snackbar.text }}

            <template v-slot:action="{ attrs }">
                <v-btn
                    text
                    v-bind="attrs"
                    @click="snackbar.show = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>

        <!-- New transaction dialogue form -->
        <v-row justify="center">
            <v-dialog v-model="txNew.show" max-width="80%" persistent>
                <v-card>
                    <v-card-title>
                        New {{ txFmtType(txNew.type) }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-subheader class="font-weight-bold pr-5 json-key-title">
                                    Transaction Currency:
                                </v-subheader>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                v-model="txNew.currency.value"
                                :disabled="true"
                                prepend
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="6">
                                <v-subheader class="font-weight-bold pr-5 json-key-title">
                                    Transaction Amount:
                                </v-subheader>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                v-model="txNew.amount"
                                label="Enter an amount"
                                type="number"
                                required
                                :rules="rules.required"
                                hint="*Required"
                                :disabled="txNew.disable.amount == 1"
                                prepend
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <!-- <v-row>
                            <v-col cols="6">
                            <v-subheader class="font-weight-bold pr-5 json-key-title">
                                Transaction Currency:
                            </v-subheader>
                            </v-col>
                            <v-col cols="6">
                                <v-select
                                    v-model="txNew.currency.value"
                                    :items="txNew.currency.options"
                                    item-text="text"
                                    item-value="value"
                                    label="Select an option"
                                    persistent-hint
                                    return-object
                                    single-line
                                    required
                                    solo
                                    :rules="rules.required"
                                    hint="*Required"
                                :disabled="txNew.disable.currency == 1"
                                ></v-select>
                            </v-col>
                        </v-row> -->

                        <v-row>
                            <v-col cols="6">
                                <v-subheader class="font-weight-bold pr-5 json-key-title">
                                    Date of Refund:
                                </v-subheader>
                            </v-col>
                            <v-col cols="6">
                                <v-menu
                                    ref="menu"
                                    v-model="txDateMenu"
                                    :close-on-content-click="true"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="txNew.date"
                                        label="Select a Date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        :rules="rules.required"
                                        :disabled="txNew.disable.date == 1"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="txNew.date"
                                    no-title
                                    scrollable
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="txDateMenu = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu.save(date)"
                                    >
                                        OK
                                    </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="6">
                                <v-subheader class="font-weight-bold pr-5 json-key-title">
                                    Time of Refund:
                                </v-subheader>
                            </v-col>
                            <v-col cols="6">
                                <v-menu
                                    ref="timeMenuRef"
                                    v-model="txNew.time.menu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="txNew.time.value"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="txNew.time.value"
                                            label="Select a Time"
                                            prepend-icon="mdi-clock-time-four-outline"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules="rules.required"
                                            :disabled="txNew.disable.time == 1"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                    v-if="txNew.time.menu"
                                    v-model="txNew.time.value"
                                    full-width
                                    @click:minute="$refs.timeMenuRef.save(txNew.time.value)"
                                    ></v-time-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click="txAction('submit')">Submit</v-btn>
                        <v-btn color="warning" @click="txAction('reset')">Reset</v-btn>
                        <v-btn color="error" @click="txAction('close')">Close</v-btn>
                    </v-card-actions>
                </v-card>
                <v-snackbar
                    v-model="snackbar.show"
                    :color="snackbar.colour"
                    timeout="5000"
                    bottom
                    rounded="pill"
                    style="z-index: 1000;"
                >
                    {{ snackbar.text }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                            text
                            v-bind="attrs"
                            @click="snackbar.show = false"
                        >
                            Close
                        </v-btn>
                    </template>
                </v-snackbar>
            </v-dialog>

            <!-- Tx Delete dialogue -->
            <v-row justify="center">
                <v-dialog
                v-model="tx.delete.show"
                persistent
                max-width="300"
                >
                <v-card>
                    <v-card-title class="text-h5">
                    Are you sure?
                    </v-card-title>
                    <!-- <v-card-text></v-card-text> -->
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red darken-1"
                        text
                        @click="txDeleteClose()"
                    >
                        No
                    </v-btn>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="txDelete()"
                    >
                        Yes
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
            </v-row>
            
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        state: Boolean,
        info: Object
    },
    data() {
        return {
            actions: {
                dispute: [
                    {index: 2, text: "Refund Alert", value: "RESOLVED"},
                    {index: 1, text: "Previously Refunded", value: "RESOLVED"},
                    {index: 0, text: "Decline Alert", value: "DECLINED"},
                ],
                cancel: [
                    {index: 0, text: "Cancelled", value: "CANCELLED"},
                    {index: 0, text: "Declined", value: "DECLINED"}
                ],
                dispute_notice: [],
                fraud_notice: [],
                cancel_notice: []
            }, 
            rules : {
                additionalComments: [v => (v.length <= 250) || 'Description must be 250 characters or less'],
                required: [value => !!value || "*Required"]
            },         
            form: {
                outcome: null,
                transactions: [],
            },
            snackbar: {
                show: false,
                text: null,
            },
            txNew: {
                show: false,
                type: '',
                date: '',
                time: {
                    menu: false,
                    value: '',
                },
                amount: '',
                currency: {
                    value: '',
                    // options: [
                    //     {text: "GBP", value: "GBP"},
                    //     {text: "USD", value: "USD"},
                    // ],
                },
                disable: {
                    amount: false,
                    currency: false,
                    date: false,
                    time: false,
                }
            },
            tx: {
                delete: {
                    id: null,
                    show: false,
                },
                disable: {
                    fullRefund: false,
                    partialRefund: false,
                }
            },
            refund: {
                status: false,
                msg: '',
                amount: '',
            }
        }
    },
    methods: {
        sendAction(action) {
            switch (action) {
                case 'submit':
                    if (this.validateForm()) {
                        axios({
                        method: 'post',
                        url: 'send-risk-response',
                        data: { userId: this.$store.state.user.id, alertResponse: this.form, item: this.info },
                        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                        })
                        .then(response => {
                            var resData = response.data;
                            // console.log(resData);

                            if (resData.success) {
                                var httpRes = resData.httpResponse;
                                if (httpRes.code == 422) {
                                    this.showPopup("orange", "This alert has already been resolved.");
                                } else {
                                    this.showPopup("green", "Successfully sent alert update.");
                                }
                                this.formReset();
                                this.$emit('show', {showBool: false, msg: "Successfully sent alert update.", colour: "green"});
                            } else {
                                this.showPopup("red", "There was a problem sending the alert update.")
                            }
                        })
                        .catch(e => {
                            console.log(e);
                            this.showPopup("red", "There was a problem sending the alert update.")
                        })
                    }
                    break;
                case 'reset':
                    this.formReset();
                    break;
                case 'close':
                    this.formReset();
                    this.$emit('show', {showBool: false});
                    break;
                default:
                    break;
            }
        },
        getActions() {
        var actions = {
            "DISPUTE": this.actions.dispute,
            "CANCEL": this.actions.cancel,
            "DISPUTE_NOTICE": this.actions.dispute_notice,
            "FRAUD_NOTICE": this.actions.fraud_notice,
            "CANCEL_NOTICE": this.actions.cancel_notice,
        };

        return actions[this.info.type];
        },
        prevRefund() {
            // var outcome = this.form.outcome;
            // if (outcome != null) {
            //     if (outcome.value == "RESOLVED") {
            //         return true;
            //     }
            // }
            // return false;

            var outcome = this.form.outcome;
            if (outcome != null) {
                if (outcome.index == 1) {
                    return true
                }
            }
            return false
        },
        newRefund() {
            var outcome = this.form.outcome;
            if (outcome != null) {
                if (outcome.index == 2) {
                    return true
                }
            }
            return false
        },
        formatIssueType() {
            var fmtTypes = {
                "DISPUTE": "Customer Dispute",
                "CANCEL": "Cancel Case",
                "DISPUTE_NOTICE": "Dispute Notice",
                "FRAUD_NOTICE": "Fraud Notice",
                "CANCEL_NOTICE": "test",
            };
            return fmtTypes[this.info.type];
        },
        showPopup(colour, text) {
        this.snackbar.show = true;
        this.snackbar.text = text;
        this.snackbar.colour = colour;
        },
        validateForm() {
            var form = this.form;

            // Check action null  
            if (form.outcome == null) {
                this.showPopup("red", "Alert outcome field is empty.")
                return false;
            }

            if (form.outcome == 'REFUNDED') {
                // Check refund status
                this.updateRefundStatus();
                if (!this.refund.status) {
                    this.showPopup("red", this.refund.msg)
                    return false;
                }
            }

            return true;
        },
        txAdd(transactionType) {
            this.txWipe();

            var newTx = this.txNew;
            newTx.show = true;
            newTx.type = transactionType;
            newTx.currency.value = this.info.currency;

            if (transactionType == "fullRefund") {
                newTx.amount = this.info.amount;

                newTx.disable.amount = true;
                newTx.disable.currency = true;
            }
        },
        txAction(actionType) {
            var newTx = this.txNew;

            switch (actionType) {
                case 'submit':
                    if (this.txValidate(newTx)) {
                        newTx.show = false;
                        var txs = this.form.transactions;
                        var insertTx = {
                            currency: newTx.currency.value,
                            amount: this.calcTwoDp(newTx.amount),
                            type: newTx.type,
                            date: String(newTx.date),
                            time: String(newTx.time.value),
                            timestamp: String(newTx.date) + " " + String(newTx.time.value),
                            color: 'blue',
                        };
                        txs.push(insertTx);
                        this.txWipe();
                        this.calcRefund();
                    }
                    break;
                case 'reset':
                    this.txReset();
                    break;
                case 'close':
                    newTx.show = false;
                    this.txWipe();
                    break;
                default:
                    break;
            }
        },
        txValidate(newTx) {
            if (newTx.amount == '') {
                this.showPopup("red", "Amount field is empty");
                return false;
            }

            // if (newTx.currency.value == '') {
            //     this.showPopup("red", "Currency field is empty");
            //     return false;
            // }
            
            if (newTx.date == '') {
                this.showPopup("red", "Date field is empty");
                return false;
            }
            
            if (newTx.time.value == '') {
                this.showPopup("red", "Time field is empty");
                return false;
            }

            return true;
        },
        txFmtType(txType) {
            var types = {
                "fullRefund": "Full Refund",
                "partialRefund": "Partial Refund",
            };

            return types[txType];
        },
        txReset() {
            var tx = this.txNew;

            this.txNew = {
                show: tx.show,
                type: tx.type,
                date: '',
                time: {
                    menu: false,
                    value: '',
                },
                amount: '',
                currency: {
                    value: '',
                    // options: [
                    //     {text: "GBP", value: "GBP"},
                    //     {text: "USD", value: "USD"},
                    // ],
                },
                disable: {
                    amount: tx.disable.amount,
                    currency: tx.disable.currency,
                    date: tx.disable.date,
                    time: tx.disable.time,
                }
            };
        },
        txWipe() {
            this.txNew = {
                show: false,
                type: '',
                date: '',
                time: {
                    menu: false,
                    value: '',
                },
                amount: '',
                currency: {
                    value: '',
                    // options: [
                    //     {text: "GBP", value: "GBP"},
                    //     {text: "USD", value: "USD"},
                    // ],
                },
                disable: {
                    amount: false,
                    currency: false,
                    date: false,
                    time: false,
                }
            };
        },
        txDelete() {
            var delTx = this.tx.delete;
            var txDel = this.form.transactions.splice(delTx.id, 1);
            this.txDeleteClose();
            this.calcRefund();
        },
        txDeleteConfirm(txIndex) {
            var delTx = this.tx.delete;
            delTx.show = true;
            delTx.id = txIndex;
        },
        txDeleteClose() {
            this.tx.delete = {
                show: false,
                id: null,
            };
        },
        getTimelineStatus() {
            if (this.form.transactions.length == 0) {
                return false
            }
            return true
        },
        showTimelimeDivider(index) {
            var txs = this.form.transactions;

            if (index != (txs.length - 1)) {
                return true;
            }

            return false;
        },
        calcRefund() {
            var runningRefund = 0;
            this.form.transactions.forEach(tx => {
                runningRefund = runningRefund + parseFloat(tx.amount);
            });
            this.refund.amount = runningRefund;
            this.updateRefundStatus();
        },
        updateRefundStatus() {
            var refund = this.refund;
            var alert = this.info;

            if (alert.amount == refund.amount) {
                refund.status = true;
                refund.msg = "Refunded amount and alert amount are equal";
                this.tx.disable.partialRefund = true;
                this.tx.disable.fullRefund = true;
            }
            if (alert.amount > refund.amount) {
                refund.status = false;
                refund.msg = "Refunded amount is lower than alert";
                this.tx.disable.partialRefund = false;
                this.tx.disable.fullRefund = false;
            }
            if (alert.amount < refund.amount) {
                refund.status = false;
                refund.msg = "Refunded amount is greater than alert";
                this.tx.disable.partialRefund = true;
                this.tx.disable.fullRefund = true;
            }
        },
        calcTwoDp(givenAmount) {
            return (Math.round(givenAmount * 100) / 100).toFixed(2)
        },
        formReset() {
            this.form = {
                outcome: null,
                transactions: [],
            };
            this.calcRefund();
        },
    }
}
</script>

<style>
    .json-key-title {
        display: inline-flex;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    /* Hint colour */
    .v-messages__message {
      color: red;
    }
</style>